import React, { useState, useRef } from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";

/* ================= DATA ================= */

const data = {
  2025: [
    {
      id: 0,
      nombre: "Equipo de League of Legends",
      descripcion:
        "Durante 2025 Rebel Fox Gaming continuó consolidando su proyecto competitivo con un roster renovado de League of Legends, participando en torneos, desarrollando nuevos talentos y representando al club en distintas competencias.",
      jugadores: [
        "Top - Lucas",
        "Jungla - Matías",
        "Mid - Nicolás",
        "ADC - Tomás",
        "Support - Agustín",
      ],
      logros: [
        "Participación en torneos oficiales",
        "Desarrollo de nuevos talentos",
      ],
    },
    {
      id: 1,
      nombre: "Equipo de Valorant",
      descripcion:
        "El roster de Valorant continuó siendo uno de los pilares competitivos de la organización, representando a Rebel Fox Gaming en distintos campeonatos durante toda la temporada.",
      jugadores: [
        "Duelista - Franco",
        "Iniciador - Ignacio",
        "Controller - Martín",
        "Sentinel - Santiago",
        "Flex - Facundo",
      ],
      logros: [
        "Participación en torneos nacionales",
        "Clasificaciones regionales",
      ],
    },
    {
      id: 2,
      nombre: "Equipo de FIFA",
      descripcion:
        "El proyecto de EA Sports FC (FIFA) continuó creciendo, ampliando la presencia de Rebel Fox Gaming en nuevas disciplinas competitivas.",
      jugadores: ["Facundo"],
      logros: [
        "Participación en competencias",
        "Representación oficial del club",
      ],
    },
    {
      id: 3,
      nombre: "Eventos Presenciales",
      descripcion:
        "2025 fue un año donde Rebel Fox Gaming tuvo una fuerte presencia en eventos, convenciones y actividades junto a la comunidad y distintas marcas, fortaleciendo su identidad dentro de los esports.",
      jugadores: [],
      logros: [
        "Participación en eventos",
        "Activaciones con marcas",
        "Encuentros con la comunidad",
      ],
    },
  ],

  2024: [
    {
      id: 4,
      nombre: "Equipo de League of Legends",
      descripcion:
        "La temporada 2024 permitió consolidar el proyecto competitivo de League of Legends con nuevos jugadores y una estructura cada vez más profesional.",
      jugadores: [
        "Top - Lucas",
        "Jungla - Matías",
        "Mid - Nicolás",
        "ADC - Tomás",
        "Support - Agustín",
      ],
      logros: [
        "Participación en torneos",
        "Desarrollo competitivo",
      ],
    },
    {
      id: 5,
      nombre: "Equipo de Valorant",
      descripcion:
        "El equipo de Valorant continuó representando al club en competencias nacionales, manteniendo el crecimiento del proyecto iniciado años atrás.",
      jugadores: [
        "Duelista - Franco",
        "Iniciador - Ignacio",
        "Controller - Martín",
        "Sentinel - Santiago",
        "Flex - Facundo",
      ],
      logros: [
        "Competencias regionales",
        "Nuevos talentos incorporados",
      ],
    },
  ],

  2023: [
    {
      id: 6,
      nombre: "Expansión de Rebel Fox Gaming",
      descripcion:
        "2023 fue un año de crecimiento. La organización comenzó nuevos proyectos junto a distintas marcas y amplió su presencia competitiva en múltiples videojuegos.",
      jugadores: [],
      logros: [
        "Inicio de proyectos con marcas",
        "Expansión de la organización",
      ],
    },
    {
      id: 7,
      nombre: "League of Legends",
      descripcion: "Roster competitivo de League of Legends.",
      jugadores: [
        "Lucas",
        "Matías",
        "Nicolás",
        "Tomás",
        "Agustín",
      ],
      logros: ["Participación en torneos"],
    },
    {
      id: 8,
      nombre: "Valorant",
      descripcion: "Roster competitivo de Valorant.",
      jugadores: [
        "Franco",
        "Ignacio",
        "Martín",
        "Santiago",
        "Facundo",
      ],
      logros: ["Participación en torneos"],
    },
    {
      id: 9,
      nombre: "Rocket League",
      descripcion: "Primer roster competitivo de Rocket League.",
      jugadores: ["Emiliano", "Joaquín", "Kevin"],
      logros: ["Ingreso a la disciplina"],
    },
    {
      id: 10,
      nombre: "Counter-Strike",
      descripcion: "Primer roster competitivo de Counter-Strike.",
      jugadores: [
        "Tomás",
        "Nicolás",
        "Franco",
        "Agustín",
        "Martín",
      ],
      logros: ["Ingreso a la disciplina"],
    },
    {
      id: 11,
      nombre: "FIFA",
      descripcion: "Inicio del proyecto competitivo de FIFA.",
      jugadores: ["Facundo"],
      logros: ["Representación del club"],
    },
  ],

  2022: [
    {
      id: 12,
      nombre: "Creadores de Contenido",
      descripcion:
        "Durante 2022 comenzaron a incorporarse creadores de contenido que ayudaron a expandir la identidad de Rebel Fox Gaming más allá de las competencias.",
      jugadores: [],
      logros: [
        "Ingreso de creadores",
        "Crecimiento de la comunidad",
      ],
    },
    {
      id: 13,
      nombre: "Primeras Marcas",
      descripcion:
        "Las primeras colaboraciones comerciales marcaron el inicio de una nueva etapa para la organización.",
      jugadores: [],
      logros: [
        "Primeras alianzas comerciales",
      ],
    },
    {
      id: 14,
      nombre: "Campeones League of Legends",
      descripcion:
        "League of Legends volvió a darle una alegría al club conquistando un nuevo campeonato.",
      jugadores: [
        "Lucas",
        "Matías",
        "Nicolás",
        "Tomás",
        "Agustín",
      ],
      logros: [
        "Campeones del torneo",
      ],
    },
  ],

  2021: [
    {
      id: 15,
      nombre: "League of Legends",
      descripcion:
        "El proyecto competitivo de League of Legends continuó creciendo y sumó nuevos campeonatos al historial del club.",
      jugadores: [
        "Lucas",
        "Matías",
        "Nicolás",
        "Tomás",
        "Agustín",
      ],
      logros: [
        "Campeones del torneo",
      ],
    },
    {
      id: 16,
      nombre: "Valorant",
      descripcion:
        "El equipo de Valorant logró consolidarse como uno de los proyectos más importantes de Rebel Fox Gaming.",
      jugadores: [
        "Franco",
        "Ignacio",
        "Martín",
        "Santiago",
        "Facundo",
      ],
      logros: [
        "Campeones del torneo",
      ],
    },
  ],

  2020: [
    {
      id: 17,
      nombre: "Primer Campeonato de League of Legends",
      descripcion:
        "Después de años de esfuerzo llegó el primer gran título de League of Legends para Rebel Fox Gaming.",
      jugadores: [
        "Lucas",
        "Matías",
        "Nicolás",
        "Tomás",
        "Agustín",
      ],
      logros: [
        "Primer campeonato oficial",
      ],
    },
    {
      id: 18,
      nombre: "Nacimiento del Equipo de Valorant",
      descripcion:
        "Con la llegada de Valorant nació una nueva etapa competitiva para Rebel Fox Gaming.",
      jugadores: [
        "Franco",
        "Ignacio",
        "Martín",
        "Santiago",
        "Facundo",
      ],
      logros: [
        "Primer torneo disputado",
      ],
    },
  ],

  2019: [
    {
      id: 19,
      nombre: "La Voz de Rebel",
      descripcion:
        "2019 fue el año en que comenzaron las redes sociales del club. A través de publicaciones, directos y contenido diario empezó a formarse la comunidad que hoy acompaña a Rebel Fox Gaming.",
      jugadores: [],
      logros: [
        "Lanzamiento de redes sociales",
        "Primer crecimiento de la comunidad",
      ],
    },
  ],

  2018: [
    {
      id: 20,
      nombre: "Nacimiento del Staff",
      descripcion:
        "Antes de los títulos existió un grupo de personas que dedicó incontables horas a organizar entrenamientos, administrar el club y construir la identidad de Rebel Fox Gaming.",
      jugadores: [
        "Manager - Martín",
        "Coach - Franco",
        "Analista - Santiago",
      ],
      logros: [
        "Creación del staff",
        "Inicio de la organización",
      ],
    },
    {
      id: 21,
      nombre: "Primer Roster Competitivo",
      descripcion:
        "Todo comenzó con un grupo de jugadores que creyó en un proyecto que recién daba sus primeros pasos. Sin recursos, pero con muchísima pasión, representaron por primera vez los colores de Rebel Fox Gaming.",
      jugadores: [
        "Top - Lucas",
        "Jungla - Matías",
        "Mid - Nicolás",
        "ADC - Tomás",
        "Support - Agustín",
      ],
      logros: [
        "Primer roster oficial",
        "Comienzo de la historia de Rebel Fox Gaming",
      ],
    },
  ],
};

/* ================= MAIN ================= */

export default function FamaUltraV2() {
  const [year, setYear] = useState(2024);
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "radial-gradient(circle at center, #0a0a0a 0%, #000 100%)",
        color: "white",
        p: 4,
      }}
    >
      {/* TITULO */}
      <Typography variant="h3" align="center" sx={{ mb: 5 }}>
        Salón de la Fama
      </Typography>

      {/* SELECTOR DE AÑO */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 6 }}>
        {Object.keys(data).map((y) => (
          <Button
            key={y}
            variant={year === y ? "contained" : "outlined"}
            onClick={() => {
              setYear(y);
              setSelectedProject(null);
            }}
            sx={{
              borderColor: "orange",
              color: "orange",
              "&.MuiButton-contained": {
                backgroundColor: "orange",
                color: "black",
              },
            }}
          >
            {y}
          </Button>
        ))}
      </Box>

      {/* PUERTAS */}
      {!selectedProject && (
        <Grid container spacing={5} justifyContent="center">
          {data[year].map((proj) => (
            <Grid item xs={12} md={4} key={proj.id}>
              <DoorUltra proj={proj} onEnter={() => setSelectedProject(proj)} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* DETALLE */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div
  initial={{ opacity: 0, scale: 0.85, y: 30 }}
  animate={{ opacity: 1, scale: 1, y: 0 }}
  exit={{ opacity: 0, scale: 0.9 }}
  transition={{ duration: 0.45 }}
>
  <Box
    sx={{
      maxWidth: "900px",
      mx: "auto",
      mt: 5,
      p: 5,
      borderRadius: "18px",
      background:
        "linear-gradient(180deg, rgba(25,25,25,.95), rgba(10,10,10,.98))",
      border: "2px solid rgba(255,140,0,.4)",
      boxShadow: "0 0 40px rgba(255,140,0,.25)",
    }}
  >
    {/* TITULO */}
    <Typography
      variant="h3"
      align="center"
      sx={{
        color: "orange",
        fontWeight: 700,
        letterSpacing: 2,
        textShadow: "0 0 15px rgba(255,140,0,.6)",
      }}
    >
      {selectedProject.nombre}
    </Typography>

    {/* LINEA */}
    <Box
      sx={{
        width: 120,
        height: 3,
        background: "orange",
        mx: "auto",
        mt: 2,
        mb: 4,
        borderRadius: 5,
        boxShadow: "0 0 15px orange",
      }}
    />

    {/* DESCRIPCIÓN */}
    {selectedProject.descripcion && (
      <Typography
        sx={{
          color: "#d7d7d7",
          fontSize: "1.08rem",
          lineHeight: 1.9,
          textAlign: "justify",
          mb: 5,
        }}
      >
        {selectedProject.descripcion}
      </Typography>
    )}

    {/* JUGADORES */}
    {selectedProject.jugadores.length > 0 && (
      <>
        <Typography
          variant="h5"
          sx={{
            color: "orange",
            fontWeight: 600,
            mb: 2,
          }}
        >
          👥 Jugadores
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1.5,
            mb: 5,
          }}
        >
          {selectedProject.jugadores.map((j, i) => (
            <Box
              key={i}
              sx={{
                px: 2,
                py: 1,
                borderRadius: 2,
                border: "1px solid rgba(255,140,0,.35)",
                background: "rgba(255,140,0,.08)",
              }}
            >
              <Typography>{j}</Typography>
            </Box>
          ))}
        </Box>
      </>
    )}

    {/* LOGROS */}
    {selectedProject.logros.length > 0 && (
      <>
        <Typography
          variant="h5"
          sx={{
            color: "orange",
            fontWeight: 600,
            mb: 2,
          }}
        >
          🏆 Logros
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {selectedProject.logros.map((l, i) => (
            <Box
              key={i}
              sx={{
                p: 1.5,
                borderLeft: "4px solid orange",
                background: "rgba(255,255,255,.03)",
              }}
            >
              <Typography>{l}</Typography>
            </Box>
          ))}
        </Box>
      </>
    )}

    <Box sx={{ textAlign: "center" }}>
      <Button
        variant="contained"
        onClick={() => setSelectedProject(null)}
        sx={{
          mt: 5,
          px: 5,
          background: "orange",
          color: "#111",
          fontWeight: "bold",
          "&:hover": {
            background: "#ff9800",
          },
        }}
      >
        ← Volver al Salón
      </Button>
    </Box>
  </Box>
</motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
}

/* ================= PUERTA ================= */

function DoorUltra({ proj, onEnter }) {
  const [open, setOpen] = useState(false);
  const audioRef = useRef(null);

  const handleClick = () => {
    setOpen(true);

    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
    }

    setTimeout(() => {
      onEnter();
      setOpen(false);
    }, 900);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        height: 340,
        perspective: "1200px",
        cursor: "pointer",
      }}
    >
      <audio ref={audioRef} src="/door.mp3" />

      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          border: "2px solid orange",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 0 25px rgba(255,140,0,0.4)",
          background: "#0d0d0d",
        }}
      >
        {/* GRAFITI (NOMBRE ARRIBA) */}
        <Typography
          sx={{
            position: "absolute",
            top: 10,
            width: "100%",
            textAlign: "center",
            fontFamily: "Impact, sans-serif",
            fontSize: "1.3rem",
            color: "orange",
            letterSpacing: 3,
            textShadow: "0 0 10px orange",
            zIndex: 5,
            transform: "rotate(-2deg)",
          }}
        >
          {proj.nombre}
        </Typography>

        {/* PUERTA IZQUIERDA */}
        <motion.div
          animate={open ? { rotateY: -100, x: -20 } : {}}
          transition={{ duration: 0.7 }}
          style={{
            position: "absolute",
            width: "50%",
            height: "100%",
            left: 0,
            background: "linear-gradient(160deg, #1a1a1a, #0d0d0d)",
            transformOrigin: "left",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              right: 12,
              top: "50%",
              width: 6,
              height: 45,
              background: "orange",
              borderRadius: 2,
            }}
          />
        </motion.div>

        {/* PUERTA DERECHA */}
        <motion.div
          animate={open ? { rotateY: 100, x: 20 } : {}}
          transition={{ duration: 0.7 }}
          style={{
            position: "absolute",
            width: "50%",
            height: "100%",
            right: 0,
            background: "linear-gradient(160deg, #1a1a1a, #0d0d0d)",
            transformOrigin: "right",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              left: 12,
              top: "50%",
              width: 6,
              height: 45,
              background: "orange",
              borderRadius: 2,
            }}
          />
        </motion.div>

        {/* LUZ CENTRAL */}
        <motion.div
          animate={open ? { opacity: 1 } : { opacity: 0 }}
          style={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: 4,
            height: "100%",
            background: "orange",
            boxShadow: "0 0 20px orange",
            zIndex: 4,
          }}
        />

        {/* HOVER GLOW */}
        <motion.div
          whileHover={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          style={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(circle, rgba(255,140,0,0.25), transparent 70%)",
            zIndex: 3,
          }}
        />
      </Box>
    </Box>
  );
}